import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../CommonElements/CommonCardHeader/CommonCardHeader";
import { H6, Image, P } from "../../../AbstractElements";
import { dynamicImage } from "../../../Service";
import { useEffect, useState } from "react";
import { getOwnStatsAction } from "../../../Api/auth";
import { toast } from "react-toastify";
import { Eye, Video } from "react-feather";
import { useAppDispatch, useAppSelector } from "../../../ReduxToolkit/Hooks";
import { setUser } from "../../../ReduxToolkit/Reducers/UserSlice";

const Statistics = () => {
  const dispatch = useAppDispatch()
  const getOwnStats = async () => {
    try {
      const response = await getOwnStatsAction();
      if (response.status === 'success') {
        console.log("user::::", response.payload)
        dispatch(setUser({
          patient_count: response.payload.patient_count,
          report_count: response.payload.report_count,
        }))
      }
      else {
        if (response.response)
          toast.error(response.response.data.message)
        else
          toast.error("Get patient stats error!")
      }
    } catch (error) {
      toast.error("Get patient failed!");
    }
  }
  const user = useAppSelector(state => state.user)
  useEffect(() => {
    getOwnStats()
  }, [])
  return (
    <Col xxl="8" xl="8" className="">
      <Card>
        <CommonCardHeader headClass="card-no-border pb-0" title={"Overview"} />
        <CardBody className="project-status-col">
          <Row className="d-flex flex-column flex-sm-row">
            <Col>
              <div className={`btn-light1-primary b-r-10`}>
                <div className={`upcoming-box`}>
                  <div className={`upcoming-icon bg-primary`}>
                    <Image src={dynamicImage(`dashboard-2/svg-icon/total.png`)} alt="icons" />
                  </div>
                  <H6>{"Total Patients"}</H6>
                  <P>{`${user.patient_count} Pages`}</P>
                </div>
              </div>
            </Col>
            {/* <Col>
              <div className={`btn-light1-secondary b-r-10`}>
                <div className={`upcoming-box`}>
                  <div className={`upcoming-icon bg-secondary`}>
                    <Image src={dynamicImage(`dashboard-2/svg-icon/check.png`)} alt="icons" />
                  </div>
                  <H6>{"Paid Patients"}</H6>
                  <P>{`${user.pages_count} Pages`}</P>
                </div>
              </div>
            </Col> */}
            <Col>
              <div className={`btn-light1-warning b-r-10`}>
                <div className={`upcoming-box`}>
                  <div className={`upcoming-icon bg-warning`}>
                    {/* <Image src={dynamicImage(`dashboard-2/svg-icon/processing.png`)} alt="icons" /> */}
                    <Eye />
                  </div>
                  <H6>{"Total Reports"}</H6>
                  <P>{`${user?.report_count} Reports`}</P>
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Statistics;
